import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const { HoverBackground, ActiveBackground, FontColor } =
  sharedComponentColorKeys.Checkbox

const checkboxStyleParts = ['container', 'checkbox', 'text'] as const

const helpers = createMultiStyleConfigHelpers(checkboxStyleParts)

export const CheckboxStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0.5rem',
      cursor: 'pointer',
      alignItems: 'center',
      borderRadius: '0.5rem',
      userSelect: 'none',
      transition: 'background-color 0.15s ease-in-out',
      width: '100%',
      _hover: {
        backgroundColor: HoverBackground,
      },
      _active: {
        backgroundColor: ActiveBackground,
      },
    },
    checkbox: {
      height: '1.5rem',
      width: '1.5rem',
      color: FontColor,
    },
    text: {
      textStyle: textStyleKeys.Body1,
      color: FontColor,
    },
  },
})

const themeKey = getName({ CheckboxStyle })
export const useCheckboxStyles = () =>
  useCustomMultiStyleConfig<typeof checkboxStyleParts>(themeKey)
